import { useState } from "react";

interface EmailValidationResult {
  isValid: boolean;
  error: string;
}

export const useEmailValidation = () => {
  const [emailError, setEmailError] = useState<string>("");

  const validateEmail = (email: string): EmailValidationResult => {
    // Verificar si está vacío
    if (!email.trim()) {
      return {
        isValid: false,
        error: "El correo electrónico es obligatorio",
      };
    }

    // Expresión regular para validar email con extensiones permitidas
    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|edu|gov|mil|co|es|mx|ar|cl|pe|ve|ec|bo|py|uy|cr|gt|hn|sv|ni|pa|do|cu|pr|info|biz|name|mobi|tel|travel|museum|aero|coop|jobs|cat|asia|xxx|post|geo|int)$/i;

    if (!emailRegex.test(email)) {
      if (!email.includes("@")) {
        return {
          isValid: false,
          error: "El correo debe contener el símbolo @",
        };
      }

      const parts = email.split("@");
      if (parts.length !== 2 || !parts[1]) {
        return {
          isValid: false,
          error: "Formato de correo inválido",
        };
      }

      const domain = parts[1];
      if (!domain.includes(".")) {
        return {
          isValid: false,
          error: "El dominio debe contener una extensión válida",
        };
      }

      return {
        isValid: false,
        error:
          "Extensión de dominio no válida. Use extensiones como .com, .org, .net, etc.",
      };
    }

    return {
      isValid: true,
      error: "",
    };
  };

  const handleEmailChange = (email: string) => {
    const validation = validateEmail(email);
    setEmailError(validation.error);
    return validation.isValid;
  };

  const clearEmailError = () => {
    setEmailError("");
  };

  return {
    emailError,
    validateEmail,
    handleEmailChange,
    clearEmailError,
  };
};
